import { FC } from 'react';

import cx from 'classnames';

import styles from './index.module.css';
import { IDividerProps } from './types';

const Divider: FC<IDividerProps> = ({ className, isMarginSm = false, noMargin = false }) => {
  return (
    <div
      className={cx(
        styles.divider,
        isMarginSm && styles.marginSm,
        noMargin && styles.noMargin,
        className && className,
        'custom-divider',
      )}
    />
  );
};

export default Divider;
